import React from "react";
import { injectIntl } from "react-intl";
import Propertii from "../../common/Propertii";
import OverdueChargesReport from "../../common/ReportOverdueCharges";

class ReportOverdueCharges extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company complete transactions report component.
     */
    render() {

        return(
            <OverdueChargesReport companyId={this.props.match.params.companyId} />
        )
    };
}

export default injectIntl(ReportOverdueCharges);